// extracted by mini-css-extract-plugin
export var aboveInput = "_l7-0";
export var actionButton = "_l7-5";
export var actionButtonContainer = "_l7-1";
export var actionIcon = "_l7-6";
export var aiInfoContainer = "_l7-2";
export var attachmentWrapper = "_l7-7";
export var bold = "_l7-3";
export var checkIcon = "_l7-8";
export var clickingRecipientBar = "_l7-11";
export var commentThreadSwitch = "_l7-a";
export var draftImage = "_l7-b";
export var draftImageContainer = "_l7-c";
export var draftImages = "_l7-e";
export var editButton = "_l7-g";
export var editor = "_l7-f";
export var editorContainer = "_l7-y";
export var editorErrorTooltipWrapper = "_l7-9";
export var headerDivider = "_l7-h";
export var icon = "_l7-i";
export var info = "_l7-j";
export var internal = "_l7-n";
export var internalDivider = "_l7-k";
export var internalMessage = "_l7-l";
export var messageInputCard = "_l7-m";
export var messageInputForm = "_l7-o";
export var messageInputFormInternal = "_l7-p";
export var options = "_l7-q";
export var publicMessageCustomer = "_l7-s";
export var publicMessageMerchant = "_l7-r";
export var removeImageButton = "_l7-d";
export var replyButtons = "_l7-t";
export var showSignatureButton = "_l7-u";
export var spinner = "_l7-v";
export var verticalButtonDivider = "_l7-4";
export var visibilitySelector = "_l7-w";
export var warning = "_l7-x";
export var wrappingText = "_l7-z";
export var writingInternalNoteTopBorder = "_l7-10";